import Vue from 'vue'
import Vuex from 'vuex'
//apiUrl: "https://api.tickettoghana.co.za"
//http://127.0.0.1:8000
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: "https://api.tickettoghana.co.za",
    agentCode:"",
    isMobile:false
  },
  getters: {
    getApiUrl(state){
      return state.apiUrl
    },
    getAgentCode(state){
      return state.agentCode
    },
    getScreenWidth(state) {
      return state.screenWidth;
    },
    isMobile(state) {
      if (state.isMobile) {
        return true;
      } else {
        return false;
      }
    },
  },
  mutations: {
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
  },
  actions: {
  },
  modules: {
  }
})
